export const Config = {
    API: "/api/v1/",
    AVAILABLE_COUNTRIES: [
        'AM',
        'BY',
        'RS',
        'KZ',
        'RU',
        'TJ',
        'AZ',
        'GE',
        'KG',
        'UZ',
    ],
    PHONE_VALIDATOR: (code, value) => {

    },
    MEDIA: {
        APK_IMAGE: '/apks/assets',
        IMAGES: `/api/v1/media`,
    },

    VALIDATE_VIDEO_SOURCE: (path) => {
        const url = new URL(path);
        if (url && ['rutube.ru', 'vk.com'].indexOf(url.host) + 1 === 0) {
            return false;
        }
        return true;
    }
};

export default Config;